<template>
  <div class="vertical nico-device-wrap">
    <div class="nico-device-name horizontal items-center justify-between">
      <span>{{ deviceInfo.deviceName }}</span>
      <van-image
          width="34" height="33"
          :src="deviceInfo.isFavorite === 1? require('@/assets/icons/nico/ic_like_active.svg'):
          require('@/assets/icons/nico/ic_like_normal.svg')"
          @click="onFavoriteDevice" show-loading>
        <template #loading>
          <van-loading type="spinner" size="33"/>
        </template>
      </van-image>
    </div>

    <div class="horizontal">
      <div class="verical device-props" style="flex:0.7">

        <div>
          <div class="nico-key">BATTERY</div>
          <div class="nico-value">{{ deviceInfo.battery }}%</div>
        </div>

        <div v-if="deviceInfo.deviceType === 3">
          <div class="nico-key">E-LIQUID</div>
          <div class="nico-value">{{ deviceInfo.liquid }}%</div>
        </div>
        <div v-if="deviceInfo.deviceType === 3">
          <div class="nico-key">FLAVOR</div>
          <div class="nico-value">{{ deviceInfo.flavorName }}</div>
        </div>
        <div v-if="deviceInfo.deviceType === 3">
          <div class="nico-key">NICOTINE</div>
          <div class="nico-value">{{ deviceInfo.nicIngredients }}%</div>
        </div>
        <div v-if="deviceInfo.deviceType === 7">
          <div class="nico-key">CONNECTIONS</div>
          <div class="nico-value">{{ deviceInfo.currentSeconds }}</div>
        </div>
        <div>
          <div class="nico-key">POWER</div>
          <div class="nico-value">8W</div>
        </div>
      </div>
      <div class="flex-1 relative " style="width: 186px;height:325px">
        <div :class="deviceInfo.deviceType === 3 ? 'device-bg': 'device-bg-battery'"></div>
        <div class="vertical items-center">
          <van-image class="device-img"
              :src="deviceInfo.flavorPicture"
              fit="contain"
              width="186"
          />

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "NicoDevice",
  props: {
    deviceInfo: {
      type: Object,
      default: () => {
        return {
          isDefaultData: true,
          flavorName: "Strawberry Ice",
          flavorPicture: require("@/assets/icons/nico/ic_default_device.svg"),
          battery: "100",
          liquid: "99"
        };
      }
    }
  },
  methods: {
    async onFavoriteDevice() {
      this.$emit("onFavoriteDevice");
    }
  }
};
</script>


<style scoped lang="less">
.nico-device-wrap {
  font-family: 'montage';
  color: white;
}

.nico-device-name {
  font-size: 48px;
  font-weight: 500;
  margin: 28px;
}

.device-props {
  margin-left: 28px;
  line-height: 1.25;

  & > * + * {
    margin-top: 16px
  }
}

.nico-key {
  font-size: 18px;
  font-weight: 400;
  color: #6B6B6B;
}

.nico-value {
  font-family: 'outfit';
  font-size: 18px;
  font-weight: 700;
}

.device-bg-battery {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translate(-50%, -10%) rotate(90deg);
  box-shadow: 0px 0px 80px 80px transparent;
  //background: linear-gradient(#FC59EB, #FFFFFF,#8EF141,#FFFFFF,#5ECCEF,#FFFFFF);
  border-image: conic-gradient(from 180deg at 50% 50%, #E14EE9 -45deg, #92F248 67deg, #5FCBF0 184deg, #E14EE9 315deg, #92F248 427deg);
  background: conic-gradient(from 180deg at 50% 50%, #E14EE9 -45deg, #92F248 67deg, #5FCBF0 184deg, #E14EE9 315deg, #92F248 427deg);
  opacity: 1;
  filter: blur(50px);
  border-radius: 50%;
  box-sizing: border-box;
  width: 186px;
  height: 186px;
}

.device-bg {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -30%);
  box-shadow: 0px 0px 90px 90px #33A8E2;
  width: 0px;
  height: 0px;
  border-radius: 50%;
}

.device-img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

}
</style>